<template>
	<div class="chargeDownload" @click="downloadPDF($event)"></div>

	<form ref="form_bill_detail" id="form_bill_detail" :action="`${SERVER_URL}/api/app/bill/${bill_id}`"
		@submit.prevent="form_bill_detail_submit()" method="post" autocomplete="off">
		<input type="hidden" name="idx" value="119">

		<section id="charge_data">
			<div class="chargeTit">{{ items?.hospital_mb?.mb_nick }} {{ commonjs.dateFormatM(billJsonData?.bill_start_date) }} 월 기공청구서</div>
			<button type="button" class="popup_close" @click="commonjs.winClose()"></button>

			<div class="chargeInfoWrap">
				<div class="chargeTxt">
					<div>
						<p>거래기간</p>
						<p>{{ commonjs.dateFormatYMD(billJsonData?.bill_start_date) }} ~ {{ commonjs.dateFormatYMD(billJsonData?.bill_end_date) }}</p>
					</div>
					<div v-if="items.bill_datetime === items.firstbill_datetime">
						<p>발행일자</p>
						<p>{{ commonjs.dateFormatYMD(items.bill_datetime) }}</p>
					</div>
					<template v-else>
					<div>
						<p>최초발행일자</p>
						<p>{{ commonjs.dateFormatYMD(items.firstbill_datetime) }}</p>
					</div>
					<div>
						<p>재발행일자</p>
						<p>{{ commonjs.dateFormatYMD(items.bill_datetime) }}</p>
					</div>
					</template>
					<div>{{ items?.hospital_mb?.mb_nick }} 귀중</div>
				</div>
				<div class="labInfoBox">
					<table>
						<colgroup>
							<col style="width:30px;">
							<col style="width:120px;">
							<col>
						</colgroup>
						<tbody>
							<!-- mb_busi.. 는 사업자등록증에서 -->
							<tr>
								<td class="cols rowspan5" rowspan="5">공급자</td>
								<td class="cols1">사업자번호</td>
								<td class="cols2">{{ items?.lab_mb?.mb_busi_num }}</td>
							</tr>
							<tr>
								<td class="cols1">상호명</td>
								<td class="cols2">{{ items?.lab_mb?.mb_busi_name }}</td>
							</tr>
							<tr>
								<td class="cols1">대표자</td>
								<td class="cols2">{{ items?.lab_mb?.mb_busi_boss }}</td>
							</tr>
							<tr>
								<td class="cols1">소재지</td>
								<td class="cols2">{{ items?.lab_mb?.mb_busi_addr }}</td>
							</tr>
							<tr>
								<td class="cols1">계좌정보</td>
								<td class="cols2">
									<span
										v-if="items?.lab_mb?.mb_bank && items?.lab_mb?.mb_bank_acc && items?.lab_mb?.mb_bank_name"
										style="display:inline-block;">{{ items?.lab_mb?.mb_bank }}</span>&nbsp;
									<span
										v-if="items?.lab_mb?.mb_bank && items?.lab_mb?.mb_bank_acc && items?.lab_mb?.mb_bank_name"
										style="display:inline-block;">{{ items?.lab_mb?.mb_bank_acc }}</span>&nbsp;
									<span
										v-if="items?.lab_mb?.mb_bank && items?.lab_mb?.mb_bank_acc && items?.lab_mb?.mb_bank_name"
										style="display:inline-block;">(예금주 : {{ items?.lab_mb?.mb_bank_name
										}})</span>&nbsp;
								</td>
							</tr>
							<!-- 240426 추가 끝 -->
						</tbody>
					</table>
				</div>
			</div>

			<div class="content content_w charge_approval">
				<div class="contIn">
					<div id="data_publishForm">
						<table>
							<thead>
								<tr>
									<th class="cols1">주문일</th>
									<th class="cols2">출고 완료일</th>
									<th class="cols3">환자명</th>
									<th class="cols4">보철명</th>
									<th class="cols5">치식</th>
									<th class="cols6">수량</th>
									<th class="cols7">단가</th>
									<th class="cols8">합계</th>
								</tr>
							</thead>
							<tbody>
							<template v-for="(aiorder, index) in items.aiorders" :key="index">
								<tr v-for="(prost, indexis) in parseInt(orderJsonData[aiorder.id].prosthesis_cnt, 10)">
									<td class="cols1">
										{{ commonjs.dateFormatYMD(orderJsonData[aiorder.id].registerDate) }}
									</td>
									<td class="cols2">{{ commonjs.dateFormatYMD(aiorder.order_complete_datetime) }}</td>
									<td class="cols3">{{ getBillDataValue(billJsonData, 'patientName', calculateIndex(index, indexis)) }}</td>
									<td class="cols4">
										<span class="line2">{{ getBillDataValue(billJsonData, 'options', calculateIndex(index, indexis)) }}</span>
										<div>{{ getBillDataValue(billJsonData, 'detail', calculateIndex(index, indexis)) }}</div>
									</td>
									<td class="cols5">
										<div class="teethWrap">
											<ul class="topLeft">
												<li v-for="(value, idx) in [18, 17, 16, 15, 14, 13, 12, 11]" :key="value" :id="'r_teeth_check' + value + '_' + 1" :data-idx="idx" :class="{ 'active': isActive(teethArray(calculateIndex(index, indexis)), value) }">
													{{ value }}
												</li>
											</ul>
											<ul class="topLeft">
												<li v-for="(value, idx) in [21, 22, 23, 24, 25, 26, 27, 28]" :key="value" :id="'r_teeth_check' + value + '_' + 2" :data-idx="idx" :class="{ 'active': isActive(teethArray(calculateIndex(index, indexis)), value) }">
													{{ value }}
												</li>
											</ul>
											<ul class="topLeft">
												<li v-for="(value, idx) in [48, 47, 46, 45, 44, 43, 42, 41]" :key="value" :id="'r_teeth_check' + value + '_' + 3" :data-idx="idx" :class="{ 'active': isActive(teethArray(calculateIndex(index, indexis)), value) }">
													{{ value }}
												</li>
											</ul>
											<ul class="topLeft">
												<li v-for="(value, idx) in [31, 32, 33, 34, 35, 36, 37, 38]" :key="value" :id="'r_teeth_check' + value + '_' + 4" :data-idx="idx" :class="{ 'active': isActive(teethArray(calculateIndex(index, indexis)), value) }">
													{{ value }}
												</li>
											</ul>
										</div>
									</td>
									<td class="cols6">{{ teethArrayCount(calculateIndex(index, indexis)) }}</td>

									<!-- price_value를 한 번만 호출하고 그 값을 변수로 저장 -->
									<td class="cols7">
										{{ 
											items?.bill_status === 'bils4' && globaljs.acc_type === 'lab' && prosthesis.length > 0
											? (() => {
												// price_value를 한 번만 호출하고 그 결과를 저장
												const price = price_value(
													getBillDataValue(billJsonData, 'options', calculateIndex(index, indexis)),
													getBillDataValue(billJsonData, 'detail', calculateIndex(index, indexis))
												);
												return price.toLocaleString(); // 단가 출력
											})()
											: Number(getBillDataValue(billJsonData, 'price', calculateIndex(index, indexis))).toLocaleString() 
										}}
									</td>

									<td class="cols8">
									{{ 
										items?.bill_status === 'bils4' && globaljs.acc_type === 'lab' && prosthesis.length > 0
										? (() => {
											// prosthesis_cnt 값을 orderJsonData에서 가져옴
											const totalIndex = index + indexis;

											// price_value 함수로 가격을 계산
											const price = price_value(
												getBillDataValue(billJsonData, 'options', calculateIndex(index, indexis)),
												getBillDataValue(billJsonData, 'detail', calculateIndex(index, indexis))
											);
											const total = price * teethArrayCount(calculateIndex(index, indexis));
											if (totalSumArray.length <= totalIndex) {
												totalSumArray.length = totalIndex + 1;  // 배열 길이를 확장
 											}
											totalSumArray[totalIndex] = total;

											// 가격 합계 출력
											return total.toLocaleString();
										})()
										: Number(getBillDataValue(billJsonData, 'price_sum', calculateIndex(index, indexis))).toLocaleString()
									}}
									</td>
								</tr>
							</template>
							</tbody>
						</table>
					</div>

					<div id="data_publishTotalForm">
						<input type="hidden" name="idx" :value="items?.id">

						<div class="approvalInfo">
							<div v-if="items?.bill_status === 'bils1'">
								<p>승인일시</p>
								<p>{{ commonjs.dateFormatYMDHis(items?.confirm_datetime) }}</p>
							</div>
							<div v-if="items?.bill_status === 'bils1'">
								<p>승인자</p>
								<p>{{ items?.confirm_mb?.mb_name }}({{ items?.confirm_mb?.mb_id }})</p>
							</div>
						</div>

						<table class="chargeTable">
							<tbody>
								<tr>
									<td class="chargeCols1">기공 합계 금액</td>
									<td class="chargeCols2">
									{{
										items?.bill_status === 'bils4' && globaljs.acc_type === 'lab' && prosthesis.length > 0
										? totalSum.toLocaleString()
										: Number(typeof billJsonData?.price_sum === 'string' ? billJsonData?.price_sum : commonjs.arraySum(billJsonData?.price_sum)).toLocaleString()
									}} 원</td>
								</tr>
								<tr>
									<td class="chargeCols1">가격 조정 금액</td>
									<td class="chargeCols2">
										<span class="hypen">-</span>
										<input v-if="items?.bill_status === 'bils4' && globaljs.acc_type === 'lab'" type="text" data-type="number" id="chargeAdjust" v-model="chargeAdjust" @keyup.enter.prevent="rePublish()" @input="handleMaxLengthCheck" @blur="handleValueCheck">
										<span v-else>{{ chargeAdjust.toLocaleString() }}</span>
										원
									</td>
								</tr>
								<tr class="total">
									<td class="chargeCols1">최종 합계 금액</td>
									<td class="chargeCols2" id="total_price">
									{{ 
										items?.bill_status === 'bils4' && globaljs.acc_type === 'lab' && prosthesis.length > 0
										? total_price.toLocaleString()
										: Number((typeof billJsonData?.price_sum === 'string' ? billJsonData?.price_sum : commonjs.arraySum(billJsonData?.price_sum)) - chargeAdjust).toLocaleString()
									}} 원</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</section>

		<div class="chargeBtnWrap" :class="items?.bill_status">
		<template v-if="items?.bill_status === 'bils2' && globaljs.acc_type === 'hospital'">
			<div class="btn_style1 okBtn" id="confirm" @click="form_bill_update_submit($event)">승인</div>
			<div class="btn_style1 refuseBtn" @click="toggleRefuseModal()">반려</div>
		</template>
		<button v-else-if="items?.bill_status === 'bils4' && globaljs.acc_type === 'lab'" type="button" class="btn_style1 okBtn" @click="rePublish()">재발행</button>
			<div v-else class="btn_style1 okBtn" @click="commonjs.winClose()">확인</div>
		</div>
		<!-- 
		청구서 상태에 따른 버튼
		
		-발행(2)
		+치과면 [승인][반려]
		
		-반려(4)
		+기공소면 [재발행]

		-나머지 승인(1), 미발행(3)
		[확인]
		-->
	</form>

	<section id="modal_refuse">
		<div class="modal_box">
			<form ref="form_bill_update" id="form_bill_update" :action="`${SERVER_URL}/api/app/bill`" @submit.prevent="form_bill_update_submit($event)" method="post" autocomplete="off">
				<div class="modal_tit">반려사유</div>
				<div class="modal_close"></div>
				<div class="modal_inner">
					<textarea v-model="form.bill_memo" id="bill_memo" placeholder="반려사유를 작성해주세요.."></textarea>
					<button type="button" class="btn_style1 refuseBtn" style="display:block;" id="refuse"
						@click="form_bill_update_submit($event)">반려</button>
				</div>
			</form>
		</div>
	</section>
	<div class="modal_bg"></div>

</template>

<script>
import header from '../components/layout/header.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch, onUpdated } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const route = useRoute();
const router = useRouter();

let other_type = ref(null);
if (globaljs.acc_type === 'lab') {
	other_type.value = "치과";
} else {
	other_type.value = "기공소";
}

const props = defineProps({
	id: {
		type: Number,
		required: true
	},
});

const bill_id = ref(props.id);

watch(
	() => props.id,
	(newVal) => {
		bill_id.value = newVal;
	}
);

const clientIP = ref(null);

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const goto_url = (url) => {
	router.push(url);
}

onMounted(async () => {
	commonjs.DOMLoaded(); // 240724 헤더가 없는 페이지는 불러와야됨
	clientIP.value = await commonjs.getIpAddress();

	// 이전에 src로 포함했던 스크립트 내용을 여기에 추가합니다.
	const script = document.createElement('script');
	script.src = "https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js";
	script.integrity = "sha512-GsLlZN/3F2ErC5ifS5QtgpiJtWd43JWSuIgh7mbzZ8zBps+dvLusV+eNQATqgA/HdeKFVgA5v3S/cIrLF7QnIg==";
	script.crossOrigin = "anonymous";
	script.referrerPolicy = "no-referrer";
	document.head.appendChild(script);

	await getModels();
	await getProsthesisSub();
});

// onUpdated 훅을 사용하여 컴포넌트 업데이트 시점에 누적된 NotFound를 출력
onUpdated(() => {
	if (NotFound.value.length > 0) {
		let txt = '';
		console.log('NotFound options and details:', NotFound.value);
		NotFound.value.forEach(not => {
			txt += `${not.options} / ${not.detail}`;
		});

		if(txt !== '') {
			//commonjs.formSwal('보철물 가격 정보 없음', txt);
		}
	}
});

const downloadPDF = (event) => {
	event.preventDefault();

	const element = document.getElementById('charge_data');
	const filename = `[${items.value?.lab_mb?.mb_busi_name}]${document.querySelector('.chargeTit').textContent}`;
	const opt = {
		margin: 0,
		filename: filename,
		image: { type: 'jpeg', quality: 1 },
		html2canvas: { scale: 1 },
		jsPDF: { unit: 'mm', format: 'a4', orientation: 'l' },
	};
	// New Promise-based usage:
	html2pdf().set(opt).from(element).save();
}

const calculateIndex = (i, j) => {
	let count = 0;
	// 이전 aiorders들의 prosthesis_cnt 길이를 더해줌
	for (let x = 0; x < i; x++) {
		count += parseInt(orderJsonData.value[items.value.aiorders[x].id].prosthesis_cnt, 10);
	}
	// 현재 i 번째의 j 값을 더해줌
	return count + j;
}

function getBillDataValue(data, key, index) {
	const value = data[key];

	if (typeof value === 'string') {
		return value;
	} else if (Array.isArray(value)) {
		return value[index];
	}

	return null;
}

const teethArray = (indexis) => {
	const teethData = getBillDataValue(billJsonData.value, 'teeths', indexis);
	return teethData.split('/').map(item => parseInt(item.trim(), 10));
};

const isActive = (arr, value) => {
	return arr.includes(value);
};

const teethArrayCount = (indexis) => {
	return getBillDataValue(billJsonData.value, 'teeths', indexis).split('/').length;
};

const rePublish = async () => {
	if (items.value.bill_status === 'bils4' && globaljs.acc_type === 'lab') {
		const re_confirm = await commonjs.confirmSwal('청구서 재발행 확인', '입력하시는 내용으로 청구서를 재발행하시겠습니까?');
		if (!re_confirm) {
			return false;
		} else {
			// 진행시작.
			await form_bill_detail_submit();
		}
	} else {
		return false;
	}
}

const toggleRefuseModal = () => {
	const content = document.getElementById('modal_refuse');
	if (content.style.display === 'none') {
		content.style.display = 'block';
	} else {
		content.style.display = 'none';
	}
	//showRefuseModal.value = !showRefuseModal.value;
}

const form = ref({
	bill_status: '',
	bill_memo: '',
	status_txt: '',
});

const items = ref([]);
const billJsonData = ref([]);
const orderJsonData = ref([]);
const prosthesis = ref([]);
const source = ref('');
const NotFound = ref([]);
const totalSumArray = ref([]);

// 전체 합계를 계산하는 computed 속성
const totalSum = computed(() => {
	return totalSumArray.value.reduce((acc, cur) => acc + cur, 0);
});

let total_price = computed(() => {
	return totalSum.value - Number(chargeAdjust.value);
});

const getTotalPrice = (index, indexis, aiorderId) => {
	if (items.value.bill_status === 'bils4' && globaljs.acc_type === 'lab' && prosthesis.length > 0) {
		// price_value 함수로 가격을 계산
		const price = price_value(
			getBillDataValue(billJsonData, 'options', calculateIndex(index, indexis)),
			getBillDataValue(billJsonData, 'detail', calculateIndex(index, indexis))
		);

		const total = price * teethArrayCount(calculateIndex(index, indexis));

		// 배열에 해당 값 저장
		totalSumArray.value[index + indexis] = total;

		// 최종 합계 반환
		return total.toLocaleString();
	}

	// 기본적으로 price_sum 값을 반환
	return Number(getBillDataValue(billJsonData, 'price_sum', calculateIndex(index, indexis))).toLocaleString();
};

const chargeAdjust = ref(0);

// 이벤트 핸들러 함수 정의
// 이벤트 핸들러 함수 정의
function handleMaxLengthCheck(event) {
	maxLengthCheck(event, chargeAdjust);
}

function handleValueCheck(event) {
	valueCheck(event, chargeAdjust);
}

// `maxLengthCheck` 함수 정의
function maxLengthCheck(event, dataObjectRef) {
	const object = event.target;

	if (typeof dataObjectRef.value === 'undefined') {
		console.debug('Invalid data object reference provided.');
		return;
	}

	// 나머지 함수 로직...
	const modelName = object.id;
	if (!modelName) {
		console.debug('Input element does not have an id attribute.');
		return;
	}

	// 숫자만 허용하는 경우, 숫자가 아닌 문자 제거
	if (object.dataset.type === 'number') {
		object.value = object.value.replace(/\D/g, '');
	}

	// maxLength 제한이 있는 경우, 입력 길이를 제한
	if (object.dataset.maxLength) {
		if (object.value.length > object.dataset.maxLength) {
			object.value = object.value.slice(0, object.dataset.maxLength);
		}
	}

	// Vue 데이터 모델 업데이트
	try {
		dataObjectRef.value = object.value;
	} catch (error) {
		console.error('Error updating data model:', error);
	}
}

function valueCheck(event, dataObjectRef) {
	const object = event.target;

	// 디버깅: 전달된 객체가 무엇인지 콘솔에 출력
	console.log('Received dataObjectRef:', dataObjectRef);

	// `dataObjectRef.value`가 유효한지 확인
	if (typeof dataObjectRef.value === 'undefined') {
		console.debug('Invalid data object reference provided.');
		return;
	}

	// `id` 속성을 사용하여 데이터 모델 속성 이름을 추론
	const modelName = object.id;
	if (!modelName) {
		console.debug('Input element does not have an id attribute.');
		return;
	}

	// 입력 값이 비어 있는 경우 0으로 설정
	let newValue = object.value.trim();
	if (newValue.length < 1) {
		newValue = '0';
	} else {
		// 숫자 변환: 앞의 불필요한 0을 제거
		newValue = parseInt(newValue, 10).toString();
	}

	// DOM 업데이트
	object.value = newValue;

	// Vue 데이터 모델 업데이트
	dataObjectRef.value = newValue;
	try {
		dataObjectRef.value = newValue;
		console.log(`Updated ${modelName} in data object:`, dataObjectRef.value);
	} catch (error) {
		console.error('Error updating data model:', error);
	}
}

const getModels = async () => {
/*
	const params = new URLSearchParams();
	params.append('mb_id', globaljs.mb_id);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);
	params.append('bill_id', bill_id.value);

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
//console.info(jsonString);
*/

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/bill/${bill_id.value}`);
//console.debug(response.data.result);
		items.value = response.data.result;
		billJsonData.value = JSON.parse(items.value.bill_json_data);
		chargeAdjust.value = Number(billJsonData?.value?.chargeAdjust);
//console.debug(billJsonData.value);
		for (let i = 0; i < items.value.aiorders.length; i++) {
			// 241022 파싱할때 특수문자 오류. sanitizeJSONString함수 추가.
			const sanitizedData = commonjs.sanitizeJSONString(items.value.aiorders[i].order_json_data);
			orderJsonData.value[items.value.aiorders[i].id] = JSON.parse(sanitizedData);
		}
//console.debug(orderJsonData.value);
	} catch (error) {
//console.error('Error getModels:', error);
	}
}

const price_value = (options, detail) => {
	if(prosthesis.value.length > 0) {
		if (items.value.bill_status === 'bils4' && globaljs.acc_type === 'lab') {
		
// console.debug(options, detail);
				// prosthesis.value에서 options와 detail이 일치하는 행을 찾음
				const matchingRow = prosthesis.value.find(row => 
					row.options === options && row.detail === detail
				);
// console.debug('matchingRow', matchingRow === undefined);
				// 이미 NotFound에 동일한 options와 detail이 존재하지 않는 경우에만 추가
				if (matchingRow === undefined || typeof matchingRow === 'undefined') {
					const alreadyInNotFound = NotFound.value.some(item => 
						item.options === options && item.detail === detail
					);

					if (!alreadyInNotFound) {
						NotFound.value.push({ options, detail });
					}
				}

				// matchingRow가 있으면 price를 가져오고, 없으면 0 반환
				const price = matchingRow ? matchingRow.price : 0;

				return price;
			}
		}
		
};

const getProsthesisSub = async () => {
	const params = new URLSearchParams();
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);
	if (globaljs.acc_type === 'lab') {
		params.append('lab_id', globaljs.mb_boss_id);
		params.append('hos_id', items.value?.hospital_mb?.mb_id);
	} else {
		params.append('lab_id', items.value?.hospital_mb?.mb_id);
		params.append('hos_id', globaljs.mb_boss_id);
	}

	params.append('hide', 0);

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
//console.info(jsonString);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/prosthesis/sub`, { params });
//console.debug(response.data.result);
		prosthesis.value = response.data.result.data;
		source.value = response.data.result.source;
	} catch (error) {
console.error('Error getProsthesisSub:', error);
	}
}

// 재발행
async function form_bill_detail_submit() {
	await withSubmitFlag(async () => {
		const params = new URLSearchParams();
		// params.append('acc_type', globaljs.acc_type);
		params.append('mb_id', globaljs.mb_id);
		params.append('bill_id', bill_id.value);
		params.append('chargeAdjust', chargeAdjust.value);

		// URLSearchParams를 객체로 변환
		const object = {};
		params.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		try {
		const response = await axios.put(`${SERVER_URL}/api/app/bill/re`, params);
	console.debug(response.data.result);
			toast.fire({
				icon: "success",
				title: `청구서를 재발행 했습니다.`
			});

			if(opener){
				opener.location.reload();
			}

			getModels();
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}

// 승인.반려
async function form_bill_update_submit(event) {
	await withSubmitFlag(async () => {
		if (event.target.id === 'confirm') {
			form.value.bill_status = 'bils1';
			form.value.status_txt = '승인';
		} else {
			form.value.bill_status = 'bils4';
			form.value.status_txt = '반려';
			if (form.value.bill_memo.replace(/[\s\n]/g, '') === '' || !form.value.bill_memo || form.value.bill_memo.trim() === '' || form.value.bill_memo.trim().length < 1) {
				event.preventDefault();
				form.value.bill_memo = '';
				commonjs.formSwal('반려사유 없음', '반려사유를 작성해주세요.', '#bill_memo', 'self');
				return false;
			}
		}

		const is_confirm = await commonjs.confirmSwal(`청구서 ${form.value.status_txt} 확인`, `${form.value.status_txt}하시겠습니까?`);
		if (!is_confirm) {
			return false;
		}

		const params = new URLSearchParams();
		params.append('acc_type', globaljs.acc_type);
		params.append('mb_id', globaljs.mb_id);
		params.append('bill_id', bill_id.value);
		params.append('bill_status', form.value.bill_status);
		params.append('bill_memo', form.value.bill_memo);

		// URLSearchParams를 객체로 변환
		const object = {};
		params.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		try {
			const response = await axios.put(`${SERVER_URL}/api/app/bill/confirm`, params);
	console.debug(response.data.result);
			toast.fire({
				icon: "success",
				title: `청구서를 ${form.value.status_txt}했습니다.`
			});

			if(opener){
				opener.location.reload();
			}

			form.value.bill_memo = '';
			document.getElementById('modal_refuse').style.display = 'none';

			getModels();
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>
<style>
.rowspan5 {
	position: relative;
}

.rowspan5:before {
	position: absolute;
	content: "";
	top: 0;
	left: -1px;
	background-color: #ccc;
	width: 1px;
	height: 100%;
}
</style>